import { observable, action, makeObservable } from 'mobx'
import { toStream } from 'utils/mobx-util'
import { share } from 'rxjs/operators'

/**
 * Basic toggle view model.
 */
export default class Toggle {
  /**
   * Whether the toggle is enabled.
   */
  @observable isEnabled: boolean = false

  /**
   * Enabled state as an observable. Emits on subscribe.
   */
  isEnabled$ = toStream(() => this.isEnabled, true).pipe(share())

  /**
   * Constructor.
   *
   * @param enabled
   */
  constructor(enabled = false) {
    makeObservable(this)
    this.isEnabled = enabled
    this.toggle = this.toggle.bind(this)
    this.enable = this.enable.bind(this)
    this.disable = this.disable.bind(this)
  }

  /**
   * Toggles the enabled state.
   */
  toggle() {
    this.set(!this.isEnabled)
  }

  /**
   * Enables the toggle.
   */
  enable() {
    this.set(true)
  }

  /**
   * Disables the toggle.
   */
  disable() {
    this.set(false)
  }

  /**
   * Sets the enabled state.
   *
   * @param enabled
   */
  @action.bound
  set(enabled: boolean) {
    this.isEnabled = enabled
  }
}
